export default __webpack_public_path__ + "static/media/doctors-customer.59083bed.png";